import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';
import {BackgroundComponent} from '../background/background.component';
import {ColorComponent} from '../color/color.component';
import {BorderComponent} from '../border/border.component';

@Component({
  selector: 'app-button',
  imports: [
    BackgroundComponent,
    ColorComponent,
    BorderComponent
  ],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './button.component.scss'
})
export class ButtonComponent extends AbstractStyleComponent {
  @ViewChild('border') borderComponent!: BorderComponent;
  @ViewChild('color') colorComponent!: BorderComponent;
  @ViewChild('background') backgroundComponent!: BorderComponent;

  getValue(): any {
    return {
      border: this.borderComponent.getValue(),
      background: this.backgroundComponent.getValue(),
      color: this.colorComponent.getValue(),
    };
  }

  setValue(value: any): void {
    this.borderComponent.setValue(value['border']);
    this.backgroundComponent.setValue(value['background']);
    this.colorComponent.setValue(value['color']);
  }
}
